import { FetchAPI } from "@renedelangel/helpers";
import { urlServidor } from '../../helpers';

const CAMPOS = `
    seguimientoSemanalSinID
    seguimientoSiniestroID
    comentario
    avance
    fechaSeguimiento
    personalSeguimiento
    usuarioID
    usuario
    altaSeguimiento
    seguimientoOrigenID
`;

//PARA EL GET:

export const GET_SEGUIMIENTOSEMANALSIN = `
query get($filtro: InputGetSeguimientoSemanalSin){
    getSeguimientoSemanalSin(filtro:$filtro){
        ${CAMPOS}
    }
}
`;

//PARA EL GET ALL:

export const GET_ALL_SEGUIMIENTOSEMANALSIN = `
query filtroGetAll($filtro: InputGetSeguimientoSemanalSin){
    getAllSeguimientoSemanalSin(filtro: $filtro){
        ${CAMPOS}
    }
}
`;

//PARA LA TABLA:

export const TABLA_SEGUIMIENTOSEMANALSIN = `
query filtro($filtro: InputFilterSeguimientoSemanalSin){
    filterSeguimientoSemanalSin(filtro: $filtro){
        listado{
            ${CAMPOS}
        }
        registros
        paginas
    }
}
`;

export const getSeguimientoSemanalSin = async (filtro, token) => {
    try {
        let { getSeguimientoSemanalSin } = await FetchAPI.graphql({
            token,
            variables: { filtro },
            url: urlServidor,
            query: GET_SEGUIMIENTOSEMANALSIN
        });
        return getSeguimientoSemanalSin;
    } catch ({ message }) { throw new Error(message); }
}

export const getAllSeguimientoSemanalSin = async (variables, token) => {
    try {
        let { getAllSeguimientoSemanalSin } = await FetchAPI.graphql({
            token,
            variables,
            url: urlServidor,
            query: GET_ALL_SEGUIMIENTOSEMANALSIN
        });
        return getAllSeguimientoSemanalSin;
    } catch ({ message }) { throw new Error(message); }
}

export const tablaSeguimientoSemanalSin = async (variables, token) => {
    try {
        let { filterSeguimientoSemanalSin } = await FetchAPI.graphql({
            token,
            variables,
            url: urlServidor,
            query: TABLA_SEGUIMIENTOSEMANALSIN
        });
        return filterSeguimientoSemanalSin;
    } catch ({ message }) { throw new Error(message); }
}
